import React, { FC } from 'react'
import { Tabs as TabsComponent } from '@ampdx/component-library/dist/components/'
import { TabsProps } from './Tabs.types'

export const Tabs: FC<TabsProps> = props => {
  return <TabsComponent content={props.content} type='Tabs' />
}
